import * as React from 'react';
import './styles/App.css';
import { AuthProvider } from './context/AuthProvider.js';
import AppNavigator from './navigation/AppNavigator.js';
import { ToastProvider } from './context/ToastProvider.js';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <AppNavigator></AppNavigator>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
